import { render, staticRenderFns } from "./Autorizaciones.vue?vue&type=template&id=2ff8b447&"
import script from "./Autorizaciones.vue?vue&type=script&lang=ts&"
export * from "./Autorizaciones.vue?vue&type=script&lang=ts&"
import style0 from "./Autorizaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ff8b447', component.options)
    } else {
      api.reload('2ff8b447', component.options)
    }
    module.hot.accept("./Autorizaciones.vue?vue&type=template&id=2ff8b447&", function () {
      api.rerender('2ff8b447', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesCompra/Autorizaciones.vue"
export default component.exports